import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';
import { ConteudoCaminho } from './conteudo-caminho';

export class CabecalhoInfo {
  titulo: string = '';
  subtitulo: string = '';
  conteudoCaminho: ConteudoCaminho[] = [];
  conteudoId: string = '';

  constructor(init?: Partial<CabecalhoInfo>) {
    Object.assign(this, init);
  }
}

@Injectable({
  providedIn: 'root'
})
export class CabecalhoService {

  constructor() { 
  }

  $status: BehaviorSubject<CabecalhoInfo> = new BehaviorSubject<CabecalhoInfo>(new CabecalhoInfo());
}
